/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {ReactNode} from 'react';
import Drawer from '@material-ui/core/Drawer';
import Menu from '@material-ui/core/Menu';
import {PopoverOrigin} from '@material-ui/core/Popover';
import {makeStyles} from '@material-ui/core/styles';
import {GenericObject} from '@ion/core/src/types/entities';
import {Hidden} from '../../layout/Hidden';

export interface ResponsiveMenuType {
  children: ReactNode;
  open: boolean;
  anchorEl?: Element | ((element: Element) => Element);
  onClose?: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
  menuClasses?: GenericObject
  popoverClasses?: GenericObject
  // places the desktop menu against its anchor - when given, the menu opens
  // at this point instead of over its anchor ...
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

const useStyles = makeStyles(theme => ({
  menuList : {
    paddingBottom : '0px'
  }
}));

export const ResponsiveMenu = ({
  children,
  open,
  anchorEl,
  onClose,
  menuClasses = {},
  popoverClasses = {},
  anchorOrigin,
  transformOrigin
}: ResponsiveMenuType) => {
  const classes = useStyles();
  return (
    <>
      <Hidden show='desktop'>
        <Menu open={open}
          classes={{
            list : classes.menuList,
            ...menuClasses
          }}
          PopoverClasses={{...popoverClasses}}
          elevation={4}
          keepMounted
          anchorEl={anchorEl}
          {...(anchorOrigin ? {anchorOrigin, transformOrigin, getContentAnchorEl: null} : {})}
          onClose={onClose}>
          {children}
        </Menu>
      </Hidden>
      <Hidden show='mobile'>
        <Drawer anchor='bottom'
          open={open}
          onClose={onClose}
          ModalProps={{
            keepMounted : true
          }}
          classes={{...menuClasses}}>
          {children}
        </Drawer>
      </Hidden>
    </>
  );
};

export default ResponsiveMenu;
